import { useLayoutEffect, useRef, useState } from "react";
import { Bar, BarChart, Tooltip, XAxis, YAxis } from "recharts";
import { format } from "date-fns";

function ChartTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-lg border border-white/10 bg-ink-800 px-3 py-2 text-xs text-zinc-200">
      <div className="text-zinc-400">{format(new Date(`${d.date}T00:00:00`), "d MMM")}</div>
      <div className="mt-0.5 font-medium text-white">{d.credits} credits</div>
      <div className="text-zinc-500">{d.requests} requests</div>
    </div>
  );
}

export function UsageChart({ daily }) {
  const data = daily || [];
  const empty = data.every((d) => !d.credits);
  const wrapRef = useRef(null);
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const ro = new ResizeObserver((entries) => setWidth(entries[0].contentRect.width));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={wrapRef} className="relative h-56 w-full" data-testid="usage-daily-chart">
      {width > 0 && (
        <BarChart data={data} width={width} height={224} margin={{ top: 8, right: 0, bottom: 0, left: 0 }}>
          <XAxis
            dataKey="date"
            tickFormatter={(v) => format(new Date(`${v}T00:00:00`), "d MMM")}
            tick={{ fill: "#52525b", fontSize: 11 }}
            axisLine={false}
            tickLine={false}
            interval={6}
          />
          <YAxis allowDecimals={false} tick={{ fill: "#52525b", fontSize: 11 }} axisLine={false} tickLine={false} width={48} />
          <Tooltip content={<ChartTooltip />} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
          <Bar dataKey="credits" fill="rgba(255,255,255,0.82)" radius={[3, 3, 0, 0]} maxBarSize={18} />
        </BarChart>
      )}
      {empty && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center text-sm text-zinc-500" data-testid="usage-chart-empty">
          No credits used in the last 30 days
        </div>
      )}
    </div>
  );
}
